export default {
  DND_ITEM: 'dndItem',
};



// WEBPACK FOOTER //
// ./src/components/DnD/ItemTypes.js